import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
} from '@mui/material';
import { Plus, FileText, Calendar, ClipboardList } from 'lucide-react';

import { useAppDispatch } from '@/store';
import { openModal } from '@/store/slices/uiSlice';

/**
 * QuickActionsWidget
 * Common actions with single-click access
 * Action-first UI principle
 */
const QuickActionsWidget: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const actions = [
    {
      icon: Plus,
      label: 'New Task',
      color: 'primary',
      onClick: () => dispatch(openModal({ type: 'taskCreate' })),
    },
    {
      icon: FileText,
      label: 'New Project',
      color: 'secondary',
      onClick: () => dispatch(openModal({ type: 'projectCreate' })),
    },
    {
      icon: Calendar,
      label: 'Request Leave',
      color: 'info',
      onClick: () => dispatch(openModal({ type: 'leaveRequest' })),
    },
    {
      icon: ClipboardList,
      label: 'Log Time',
      color: 'success',
      onClick: () => dispatch(openModal({ type: 'timeCorrection' })),
    },
  ];

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
          Quick Actions
        </Typography>

        <Grid container spacing={1}>
          {actions.map((action) => {
            const Icon = action.icon;
            return (
              <Grid item xs={6} key={action.label}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={action.onClick}
                  sx={{
                    py: 1.5,
                    flexDirection: 'column',
                    gap: 0.5,
                    borderColor: 'divider',
                    '&:hover': {
                      borderColor: `${action.color}.main`,
                      bgcolor: `${action.color}.50`,
                    },
                  }}
                >
                  <Icon size={20} />
                  <Typography variant="caption" sx={{ fontWeight: 500 }}>
                    {action.label}
                  </Typography>
                </Button>
              </Grid>
            );
          })}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default QuickActionsWidget;
